import {
    apiRequest,
    timkerjaPeriod,
    timkerjaPeriodCreate,
    timkerjaTeamList,
    timkerjaTeamCreate,
    timkerjaMembers,
    timkerjaMemberCreate,
    timkerjaMemberLeader,
    timkerjaDelete,
    timkerjaDeleteMember,
    timkerjaActivate,
    timkerjaPeriodDelete,
    timkerjaOrganization,
    timkerjaLeader,
    timkerjaDetailTeam,
    timkerjaGenerate,
    timkerjaGroupMember,
    timkerjaConfigUpdate,
    timkerjaConfigDownload,
    timkerjaImport,
    timkerjaSync,
    timkerjaTemplate,
    timkerjaUnitKerja,
    timkerjaDeleteSemua
} from "../../../../../services/adapters/master/penialian360Service"

class TeamRepository {

    fetchDeleteAll = async (query) => {
        return await apiRequest("post", timkerjaDeleteSemua, {
            body: query
        }, true)
    }

    fetchUnitKerja = async (query) => {
        return await apiRequest("get", timkerjaUnitKerja, {
            params: query
        }, true)
    }

    fetchTemplate = async (query) => {
        return await apiRequest("get", timkerjaTemplate, {
            params: query
        }, true)
    }

    fetchSync = async (query) => {
        return await apiRequest("post", timkerjaSync, {
            body: query
        }, true)
    }

    fetchImport = async (query) => {
        return await apiRequest("post", timkerjaImport, {
            body: query
        }, true)
    }

    fetchDownload = async (query) => {
        return await apiRequest("get", timkerjaConfigDownload, {
            params: query
        }, true)
    }
    
    fetchConfigUpdate = async (query) => {
        return await apiRequest("post", timkerjaConfigUpdate, {
            body: query
        }, true)
    }

    fetchGroupMember = async (query) => {
        return await apiRequest("get", timkerjaGroupMember, {
            params: query
        }, true)
    }

    fetchGenerate = async (query) => {
        return await apiRequest("post", timkerjaGenerate, {
            body: query
        }, true)
    }

    fetchDetailTeam = async (query, cancelToken) => {
        return await apiRequest("get", timkerjaDetailTeam, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchLeader = async (query, cancelToken) => {
        return await apiRequest("get", timkerjaLeader, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }


    fetchOrganization = async (query, cancelToken) => {
        return await apiRequest("get", timkerjaOrganization, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchPeriodDelete = async (query) => {
        return await apiRequest("post", timkerjaPeriodDelete, {
            body: query
        }, true)
    }

    fetchPeriod = async (query, cancelToken) => {
        return await apiRequest("get", timkerjaPeriod, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchPeriodCreate = async (query) => {
        return await apiRequest("post", timkerjaPeriodCreate, {
            body: query
        }, true)
    }

    fetchTeamList = async (query, cancelToken) => {
        return await apiRequest("get", timkerjaTeamList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchTeamCreate = async (query) => {
        return await apiRequest("post", timkerjaTeamCreate, {
            body: query
        }, true)
    }

    fetchMembers = async (query) => {
        return await apiRequest("get", timkerjaMembers, {
            params: query
        }, true)
    }

    fetchMemberCreate = async (query) => {
        return await apiRequest("post", timkerjaMemberCreate, {
            body: query
        }, true)
    }

    fetchMemberLeader = async (query) => {
        return await apiRequest("post", timkerjaMemberLeader, {
            body: query
        }, true)
    }

    fetchTeamDelete = async (query) => {
        return await apiRequest("post", timkerjaDelete, {
            body: query
        }, true)
    }

    fetchTeamDeleteMember = async (query) => {
        return await apiRequest("post", timkerjaDeleteMember, {
            body: query
        }, true)
    }

    fetchTeamActivate = async (query) => {
        return await apiRequest("post", timkerjaActivate, {
            body: query
        }, true)
    }

}

export default TeamRepository